<template>
  <div class="page flex-col">
    <div class="block_9 flex-row">
      <div class="box_63 flex-col">
        <PageHeader />
        <div class="sub-page-content" v-html="content" />
        <PageFooter />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '../detail/components/PageHeader.vue'
import PageFooter from '../detail/components/PageFooter.vue'
import { fetchSiteConfig } from '../../api'

import '../detail/assets/css/common.css'
import '../detail/assets/css/header.css'
import '../detail/assets/css/footer.css'
import './pages.css'

export default {
  name: 'AdService',
  components: { PageHeader, PageFooter },
  data() {
    return {
      content: ''
    }
  },
  created() {
    this.loadContent()
  },
  methods: {
    async loadContent() {
      try {
        this.content = await fetchSiteConfig('GGFW')
      } catch (err) {
        console.error('获取广告服务内容失败', err)
      }
    }
  }
}
</script>
